import React from "react"
import { Text, TextProps, createStyles } from "@design-system/core"
import { useInteractive } from "@design-system/interactive"

import { LinkProps } from "./types"
import { useLink } from "./useLink"

export const Link = React.forwardRef<any, LinkProps>((props, ref) => {
  const { withInteractive, ...others } = props
  // get integration status
  const {
    isDisabled,
    isHovered,
    isPressed,
    isFocused,
    ...inveractiveProps
  } = useInteractive({ ...others, isDisabled: !withInteractive })
  const linkProps = useLink<TextProps>(inveractiveProps)

  return (
    <Text
      as="a"
      {...linkProps}
      ref={ref}
      style={[
        (isHovered || isPressed || isFocused) &&
          (linkProps.interactiveStyle || styles.withInteractive),
        linkProps.style,
      ]}
    />
  )
})

Link.defaultProps = {
  withInteractive: true,
}

const styles = createStyles({
  withInteractive: {
    outlineStyle: "none",
    textDecorationLine: "underline",
  },
})
